var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 10.7V8.53333H16.8L16.0667 10.7H0.833333ZM0.833333 14.9333V12.7333H15.4667L14.7667 14.9333H0.833333ZM13.7667 0.166667C15.2111 0.166667 16.5222 0.377778 17.7 0.8C18.8778 1.2 19.8778 1.78889 20.7 2.56667C21.5222 3.32222 22.1 4.25556 22.4333 5.36667L18.2333 7.26667C18.0333 6.2 17.5333 5.42222 16.7333 4.93333C15.9333 4.42222 15 4.16667 13.9333 4.16667C12.7333 4.16667 11.7333 4.44444 10.9333 5C10.1556 5.55556 9.56667 6.38889 9.16667 7.5C8.78889 8.58889 8.6 9.92222 8.6 11.5C8.6 13.8556 9.01111 15.6667 9.83333 16.9333C10.6778 18.2 12.0556 18.8333 13.9667 18.8333C15.0778 18.8333 16 18.5556 16.7333 18C17.4667 17.4222 17.9556 16.5556 18.2 15.4L22.5667 16.7C22.2333 18.0556 21.6556 19.1889 20.8333 20.1C20.0333 21.0111 19.0222 21.7 17.8 22.1667C16.6 22.6111 15.2667 22.8333 13.8 22.8333C11.6222 22.8333 9.75556 22.3889 8.2 21.5C6.64444 20.5889 5.44444 19.2889 4.6 17.6C3.77778 15.9111 3.36667 13.8778 3.36667 11.5C3.36667 9.12222 3.78889 7.08889 4.63333 5.4C5.5 3.71111 6.71111 2.42222 8.26667 1.53333C9.82222 0.622223 11.6556 0.166667 13.7667 0.166667Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEuro);
export default __webpack_public_path__ + "static/media/Ic_euro.f0875f291a9b52e1831308bc97362249.svg";
export { ForwardRef as ReactComponent };